import { cn } from '../lib/cn';

export const Skeleton = ({ className }: { className?: string }) => (
  <div
    className={cn('animate-pulse rounded-md bg-bg-secondary', className)}
    aria-hidden="true"
  />
);
